import { CircularProgress } from '@mui/material';

import { GDMCircularProgressComponent } from './GDMCircularProgress.type';

const GDMCircularProgress: GDMCircularProgressComponent = props => <CircularProgress {...props} />;

export default GDMCircularProgress;
